export const getArticle = (word: string): string => {
	if (!word) {
		return '';
	}

	const vowels = new Set('aeiouAEIOU');
	return vowels.has(word[0]) ? 'an' : 'a';
};

export const capitalizeFirstLetter = (text: string): string => {
	if (!text) {
		return '';
	}

	return text.charAt(0).toUpperCase() + text.slice(1);
};
